import { getSessionToken } from '../auth-client';
import { apiFetch } from '../api-client';

export type RowAction = 'create' | 'update' | 'skip' | 'error';

export interface ParsedAssetData {
  name: string;
  categoryCode: string;
  department?: string;
  userName?: string;
  purchasedAt?: string;
  cost?: number;
  serialNumber?: string;
  supplier?: string;
  invoiceNumber?: string;
  warrantyUntil?: string;
  depreciationMethod?: 'straight' | 'declining' | 'units';
  depreciationYears?: number;
  depreciationStartDate?: string;
  costAccount?: string;
  depreciationAccount?: string;
  location?: string;
  notes?: string;
}

export interface PreviewRow {
  rowIndex: number;
  code: string;
  data: ParsedAssetData;
  action: RowAction;
  errors: string[];
  existingId?: string;
  categoryName?: string;
}

export interface AssetImportPreview {
  sheetName: string;
  totalRows: number;
  toCreate: number;
  toUpdate: number;
  toSkip: number;
  toError: number;
  rows: PreviewRow[];
}

export interface AssetCommitResult {
  created: number;
  updated: number;
  errors: Array<{ code: string; message: string }>;
}

async function uploadPreview(file: File): Promise<AssetImportPreview> {
  const token = getSessionToken();
  const fd = new FormData();
  fd.append('file', file);
  const res = await fetch('/api/asset-import/preview', {
    method: 'POST',
    headers: token ? { Authorization: `Bearer ${token}` } : {},
    body: fd,
  });
  if (!res.ok) {
    const text = await res.text().catch(() => '');
    throw new Error(`Preview fail: ${res.status} ${text}`);
  }
  return (await res.json()) as AssetImportPreview;
}

async function downloadTemplate(): Promise<void> {
  const token = getSessionToken();
  const res = await fetch('/api/asset-import/template', {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
  if (!res.ok) throw new Error(`Tải template fail: ${res.status}`);
  const cd = res.headers.get('content-disposition') || '';
  const nameMatch = cd.match(/filename="?([^";]+)"?/i);
  const fileName = nameMatch?.[1] || 'template-ghi-tang-tscd.xlsx';
  const blob = await res.blob();
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = fileName;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 5000);
}

export const assetImportApi = {
  preview: uploadPreview,
  commit: (rows: Array<{ code: string; data: ParsedAssetData; action: 'create' | 'update' }>) =>
    apiFetch<AssetCommitResult>('/api/asset-import/commit', {
      method: 'POST',
      body: JSON.stringify({ rows }),
    }),
  downloadTemplate,
};
